<div *ngIf="filteredContractDefinitions$ | async as contractDefinitions" id="wrapper" [style.height]="contractDefinitions.length === 0 ? 'calc(100% - 98px)' : 'auto'">  <div class="container">
        <mat-form-field appearance="outline" class="search-form-field" color="accent">
            <mat-label>Search by id</mat-label>
            <input (input)="onSearch()" [(ngModel)]="searchText" matInput>
            <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>

        <button (click)="onCreate($event)" color="accent" mat-flat-button>
            <mat-icon>add_circle</mat-icon>
            Create data offer
        </button>

    </div>

    <div *ngIf="contractDefinitions.length === 0" class="empty-wrapper">
        <div class="no-assets-message">
            <mat-icon style="font-size: 64px; width: 64px; height: 64px;">upload</mat-icon>
            <h2>No data offers available</h2>
            <p>The connector doesn't have any data offers.</p>
            <p>Create a new data offer to get started.</p>
        </div>
    </div>

    <div class="cards-grid" *ngIf="contractDefinitions.length > 0">

        <mat-card *ngFor="let contractDefinition of contractDefinitions" class="contract-definition-card">
            <mat-card-header>
                <mat-icon mat-card-avatar>upload</mat-icon>
                <mat-card-title>{{contractDefinition.id}}</mat-card-title>
            </mat-card-header>
            <mat-divider class="definition-header-divider"></mat-divider>
            <mat-card-content>
                <div class="asset-properties">
                    <div class="asset-property-row">
                        <div class="asset-property-top">
                            <mat-icon>policy</mat-icon>
                            <div class="asset-property-header">Access policy</div>
                        </div>
                        <div class="asset-property-value">{{contractDefinition.accessPolicyId}}</div>
                    </div>

                    <div class="asset-property-row">
                        <div class="asset-property-top">
                            <mat-icon>policy</mat-icon>
                            <div class="asset-property-header">Contract policy</div>
                        </div>
                        <div class="asset-property-value">{{contractDefinition.contractPolicyId}}</div>
                    </div>
                </div>

                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            Selectors
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="asset-properties">
                        <div *ngFor="let criterion of contractDefinition.assetsSelector" class="asset-property-row">
                            <div class="asset-property-top">
                                <mat-icon mat-icon style="color: white">check</mat-icon>
                                <div class="asset-property-header">Version</div>
                            </div>
                            <div class="asset-property-value">{{criterion.mandatoryValue('edc', 'operandLeft')}}
                                {{criterion.mandatoryValue('edc', 'operator')}} {{criterion.mandatoryValue('edc',
                                'operandRight')}}</div>
                        </div>
                    </div>
                </mat-expansion-panel>

            </mat-card-content>

            <mat-card-footer class="contract-definition-card-footer">
                <button (click)="onDelete(contractDefinition)" color="warn" class="card-footer-button"
                    mat-stroked-button>
                    <mat-icon>delete</mat-icon> Delete
                </button>
            </mat-card-footer>
        </mat-card>
    </div>

    <mat-paginator *ngIf="contractDefinitions.length" [length]="contractDefinitions.length" hidePageSize="true" pageSize="contractDefinitions.length">
    </mat-paginator>
</div>